
import React from "react";
import { UpdateItem } from "./types";
import { UpdateTimelineItem } from "./UpdateTimelineItem";

interface UpdatesTimelineProps {
  updates: UpdateItem[];
}

export function UpdatesTimeline({ updates }: UpdatesTimelineProps) {
  return (
    <div className="relative">
      <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200"></div>
      <div className="space-y-8">
        {updates.map((update, index) => (
          <UpdateTimelineItem key={index} update={update} />
        ))}
      </div>
    </div>
  );
}
